export const issn = '251113';
export const token_type = 'token';
//export const url_dev = 'http://172.30.1.101:5000';
export const url_dev = 'https://api-m3guo.17m3.com';
export const url_production = 'https://api-m3guo.17m3.com';